import { render, staticRenderFns } from "./PagamentoFaturar.vue?vue&type=template&id=99ad525e"
import script from "./PagamentoFaturar.vue?vue&type=script&lang=js"
export * from "./PagamentoFaturar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports